import interceptor from "@/plugins/interceptor";
const pathController = "/LearningUserProfile";

export default {
  state: () => ({}),
  mutations: {},
  actions: {
    async profile_profileData(_, userId) {
      return await interceptor.authenticate.get(
        `${process.env.VUE_APP_API_LMS_URL}${pathController}/${userId}/profiles`
      );
    },
    async profile_creationOptions() {
      return await interceptor.authenticate.get(
        `${process.env.VUE_APP_API_LMS_URL}${pathController}/creationOptions`
      );
    },
    //     await axios.put(`/api/v1/LearningUserProfile/${userId}/profiles/personalData`, payload);
    async profile_personalData(_, { userId, payload }) {
      return await interceptor.authenticate.put(
        `${process.env.VUE_APP_API_LMS_URL}${pathController}/${userId}/profiles/personalData`,
        payload
      );
    },
    //     await axios.put(`/api/v1/LearningUserProfile/${userId}/profiles/contactData`, payload);
    async profile_contactData(_, { userId, payload }) {
      return await interceptor.authenticate.put(
        `${process.env.VUE_APP_API_LMS_URL}${pathController}/${userId}/profiles/contactData`,
        payload
      );
    },
    // await axios.put(`/api/v1/LearningUserProfile/${userId}/profiles/professionalData`, payload);
    async profile_professionalData(_, { userId, payload }) {
      return await interceptor.authenticate.put(
        `${process.env.VUE_APP_API_LMS_URL}${pathController}/${userId}/profiles/professionalData`,
        payload
      );
    },
    async profile_profilePicture(_, { userId, payload }) {
      return await interceptor.authenticate.put(
        `${process.env.VUE_APP_API_LMS_URL}${pathController}/${userId}/profiles/picture`,
        payload
      );
    }
  },
};
